module.exports = __webpack_public_path__ + "assets/img/rakumartandGoogle.0aa4ac30.svg";